import React from 'react';
import styled from 'styled-components';
import useLocale from '../hooks/useLocale';

const SIDDHANTA_OPTIONS = [
  { value: 'drik' },
  { value: 'vakyam' },
  { value: 'compare' },
];

const Select = styled.select`
  padding: 10px 12px;
  border: 1px solid ${p => p.theme.colors.border};
  border-radius: ${p => p.theme.radius.md}px;
  font-size: ${p => p.theme.typography.sizes.md};
  background: ${p => p.theme.colors.surface};
  color: ${p => p.theme.colors.text.primary};
  cursor: pointer;
  width: 100%;
  &:focus { border-color: ${p => p.theme.colors.primary}; outline: none; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

const SiddhantaSelector = ({ value, onChange, disabled = false, lang = 'en' }) => {
  const t = useLocale(lang, 'siddhanta');
  return (
    <Select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      aria-label={t.label || 'Siddhanta'}
    >
      {SIDDHANTA_OPTIONS.map(opt => (
        <option key={opt.value} value={opt.value}>
          {t[opt.value] || opt.value}
        </option>
      ))}
    </Select>
  );
};

export default SiddhantaSelector;
